<tvcore-alert *ngIf="toast$ | async as toast" [action]="toast.action" [stretch]="true" [type]="toast.type" (close)="clearToast()">
	<p [innerHTML]="toast.message"></p>
</tvcore-alert>
